import React from "react";

function OptionsDataByAttributePath(options, attributePathDescription, attributePathValue, initialOptionEmpty) {
    if (options && options.length > 0) {
        const optionsMapped = options.map(option => {
            return (
                <option key={option.id} value={getAttribute(option, attributePathValue)}>
                    {getAttribute(option, attributePathDescription)}
                </option>
            );
        });

        return (
            <>
                {initialOptionEmpty ? <option value=""></option> : null}
                {optionsMapped}
            </>
        );
    }
    return null;
}

function getAttribute(option, attributePath) {
    if (!attributePath) {
        return option.id;
    }
    let nestedAttribute = option;

    for (const key of attributePath) {
        nestedAttribute = nestedAttribute[key];

        if (nestedAttribute === undefined || nestedAttribute === null) {
            return '';
        }
    }

    return nestedAttribute;
}

export default OptionsDataByAttributePath;
